import { render, staticRenderFns } from "./VerticalContainer.vue?vue&type=template&id=ec290f84"
import script from "./VerticalContainer.vue?vue&type=script&lang=js"
export * from "./VerticalContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports